import { APIClient } from "../helpers/api_helper";
import { ApiResponse } from "../types/api";

const api = new APIClient();

export interface TeamPermissionRole {
  name: string;
  display_name: string;
}

export interface TeamPermissionItem {
  name: string;
  display_name: string;
  granted_roles: string[];
}

export interface TeamPermissionGroup {
  name: string;
  display_name: string;
  permissions: TeamPermissionItem[];
}

export interface TeamPermissionMatrix {
  roles: TeamPermissionRole[];
  groups: TeamPermissionGroup[];
}

export const getTeamPermissions = (): Promise<ApiResponse<TeamPermissionMatrix>> =>
  api.get<ApiResponse<TeamPermissionMatrix>>("/settings/team-permissions");
